import { useMemo } from 'react';
import { mainMenuItems } from './utils/utils';
import { appRoutes } from '../../../constants/appRoutes';
import { MainMenuItem } from './utils/types';
import { useSelector } from 'react-redux';
import { selectIsDisableAi } from '../../../reducers/userInfoReducer';
import { selectDefaultCreationEnvironment } from '../../pages/environments/environmentsReducer';
import { SNOWFLAKE_ALLOWED_ROUTES } from '../../../constants/snowflakeConstants';

export const useMenuItemsWithPermissions = (): MainMenuItem[] => {
  const isDisableAi = useSelector(selectIsDisableAi);
  const defaultCreationEnv = useSelector(selectDefaultCreationEnvironment);
  const isSnowflakeEnv = defaultCreationEnv?.orgType === 'snowflake';

  const menuItemsWithPermissions = useMemo(() => {
    return mainMenuItems.map((item) => {
      if (item.route === appRoutes.agenticLayer.route) {
        return {
          ...item,
          isHidden: isDisableAi,
        };
      }

      if (isSnowflakeEnv) {
        return {
          ...item,
          isHidden: !SNOWFLAKE_ALLOWED_ROUTES.includes(item.route),
        };
      }

      return item;
    });
  }, [isDisableAi, isSnowflakeEnv]);

  return menuItemsWithPermissions;
};
